import {
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useParams } from "react-router-dom";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useEffect, useState } from "react";
import SelectInputField from "../forms/formElements/SelectInputField";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import BasicModal from "../ui/BasicModal";
import BasicAutoComplete from "../ui/BasicAutoComplete";
import {
  filterConstants,
  mobileConstraints,
} from "../../constants/AppConstants";

export function ViewShopUser() {
  const shopUserList = useAppSelector(
    (state: any) => state.persistReducers.shopUserSlice?.shopUserList
  );

  const params = useParams();
  const { shopuserId } = params;

  const singleShopper = shopUserList.filter(
    (shopper: any) => shopper.email === shopuserId
  );
  const shop = singleShopper[0];
  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const [error, setError] = useState(false);
  const [status, setStatus] = useState({ status: "" });
  const [merchant, setMerchantState] = useState({ merchant: "" });
  const [first_name, setFirst_name] = useState(shop.first_name);
  const [last_name, setLast_name] = useState(shop.last_name);
  const [role, setRole] = useState({ role: "" });
  const [email, setEmail] = useState(shop.email);
  const [mobileNumber, setMobileNumber] = useState(shop.mobileNumber);
  const buttonStyles = useButtonStyles();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [noChangesMade, setNoChangesMade] = useState<boolean>(false);
  const [merchantRoles, setMerchantRoles] = useState<string[]>([]);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const merchantListFromRedux = entireList.map((entity: any) => {
    return {
      id: entity.id,
      label: entity.name,
      external_id: entity.external_id,
    };
  });

  const formValidate = () => {
    if (first_name === "") return false;
    if (last_name === "") return false;
    if (
      mobileNumber === "" ||
      mobileNumber.length < 8 ||
      mobileNumber.length > 13
    )
      return false;
    if (email === "" || error) return false;
    if (
      merchant.merchant === "" ||
      merchant.merchant === filterConstants.Select
    )
      return false;
    if (status.status === "" || status.status === filterConstants.Select)
      return false;

    return true;
  };
  const sendUpdateEmail = async () => {
    try {
      const changes = [];
      if (first_name !== shop.first_name) {
        changes.push(`First Name: ${shop.first_name} -> ${first_name}`);
      }
      if (last_name !== shop.last_name) {
        changes.push(`Last Name: ${shop.last_name} -> ${last_name}`);
      }
      if (email !== shop.email) {
        changes.push(`Email: ${shop.email} -> ${email}`);
      }

      if (mobileNumber !== shop.mobileNumber) {
        changes.push(`Mobile Number: ${shop.mobileNumber} -> ${mobileNumber}`);
      }
      if (changes.length === 0) {
        setNoChangesMade(true);
        return;
      }
      const changeMessage = changes.join("<br><br>");

      const emailData = {
        email: email,
        subject: "Shop user update",
        body: `
        <div style="margin: 10px; padding: 10px; line-height: 1.5;">
          Shop user information has been updated.<br><br>
          <strong>Changes:</strong><br><br>
          ${changeMessage}
        </div>
      `,
        fileType: "text",
      };

      const emailResponse = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.sendEmail,
        emailData
      );
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const updateShopUser = async () => {
    const external_id = merchantListFromRedux.find(
      (ele: any) => ele.label === merchant.merchant
    )?.external_id;

    const payload = {
      first_name,
      last_name,
      email,
      mobile: mobileNumber,
      ...status,
      ...merchant,
      external_id,
      user_role: role.role,
    };
    try {
      setLoading(true);
      const response = await axios.put(
        process.env.REACT_APP_API_URL + APIConstants.addShopUser,
        payload
      );

      response.data.data && setShowModal(true);
      if (response.data.data) {
        await sendUpdateEmail();
        setShowModal(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (e: any) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const isValidEmail = emailRegex.test(e.target.value);
    if (isValidEmail) {
      setEmail(e.target.value);
      setError(false);
    } else setError(true);
  };
  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Merchant"
        );
        const data = response.data.data;
        const roles = data.map((item: any) => {
          return item.name;
        });
        setMerchantRoles(roles);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    fetchRoleList();
  }, []);
  return (
    <Grid>
      <Grid
        item
        width={"100%"}
        height={"6.25rem"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        mb={4}
        sx={{ background: theme.color?.background }}
      >
        <Grid display={"flex"} alignItems={"center"} px={4} gap={2}>
          <Button component={Link} to="/admin?tab=shopUser">
            <ArrowBackIosIcon />
          </Button>
          <Typography
            variant="h6"
            sx={{
              color: theme?.color?.primary,
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "600",
            }}
          >
            {shop.name}
          </Typography>
        </Grid>
      </Grid>

      <Grid>
        <Grid>
          <Grid
            container
            sx={{
              backgroundColor: theme?.color?.background,
              borderRadius: "8px",
            }}
            width={"80%"}
            margin={3}
            p={3}
            alignSelf={"center"}
          >
            <Grid item container p={4}>
              <Grid item container>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    First Name *
                  </Typography>
                  <TextField
                    type="text"
                    fullWidth
                    size="small"
                    defaultValue={first_name}
                    onChange={(e) => setFirst_name(e.target.value)}
                    error={first_name === ""}
                    helperText={first_name === "" ? "Required field" : ""}
                  ></TextField>
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Last Name *
                  </Typography>
                  <TextField
                    type="text"
                    fullWidth
                    size="small"
                    defaultValue={last_name}
                    onChange={(e) => setLast_name(e.target.value)}
                    error={last_name === ""}
                    helperText={last_name === "" ? "Required field" : ""}
                  ></TextField>
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Mobile Number *
                  </Typography>
                  <TextField
                    type="number"
                    fullWidth
                    size="small"
                    defaultValue={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    error={
                      mobileNumber === "" ||
                      mobileNumber.length < mobileConstraints.mobileMin ||
                      mobileNumber.length > mobileConstraints.mobileMax
                    }
                    helperText={
                      mobileNumber.length < mobileConstraints.mobileMin ||
                      mobileNumber.length > mobileConstraints.mobileMax
                        ? "Invalid Number"
                        : ""
                    }
                  ></TextField>
                </Grid>
              </Grid>

              <Grid container item mt={2}>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Email
                  </Typography>
                  <TextField
                    fullWidth
                    type="email"
                    size="small"
                    defaultValue={email}
                    onChange={(e) => validateEmail(e)}
                    error={error || email === ""}
                    helperText={error ? "Invalid email address" : ""}
                    disabled={disabled}
                    sx={{
                      background: disabled ? theme.color?.greyBackground : "",
                    }}
                  ></TextField>
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Merchant
                  </Typography>
                  <BasicAutoComplete
                    defaultValue={shop.merchant}
                    setState={setMerchantState}
                    stateKey="merchant"
                    secondaryStateKey="merchantType"
                    options={merchantListFromRedux}
                    required={true}
                    readonly
                  />
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Status
                  </Typography>
                  <SelectInputField
                    sx={{ width: "100%" }}
                    setState={setStatus}
                    stateKey="status"
                    defaultValue={shop.status}
                    align="left"
                    options={[
                      filterConstants.Select,
                      filterConstants.Active,
                      filterConstants.Inactive,
                    ]}
                    error={
                      status.status === "" ||
                      status.status === filterConstants.Select
                    }
                  />
                </Grid>
              </Grid>
              <Grid container item mt={2}>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Role *
                  </Typography>
                  <SelectInputField
                    sx={{ width: "100%" }}
                    setState={setRole}
                    stateKey="role"
                    defaultValue="Tenant Admin"
                    align="left"
                    options={merchantRoles}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item width={"100%"}>
              <Grid
                container
                item
                justifyContent={"end"}
                padding={2}
                borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
                paddingTop={4}
                pr={12}
              >
                <Button
                  sx={{
                    ...buttonStyles.outlinedSecondary,
                    width: "20%",
                    mr: 2,
                  }}
                  variant="outlined"
                  component={Link}
                  to="/admin?tab=shopUser"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  sx={{ ...buttonStyles.containedSecondary, width: "20%" }}
                  variant="contained"
                  onClick={updateShopUser}
                  startIcon={loading && <CircularProgress size={20} />}
                  disabled={!formValidate()}
                >
                  {loading ? "Updating..." : "Update"}
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {showModal &&
            (uploadError ? (
              <BasicModal
                title={"Something went wrong"}
                success={false}
                setState={setShowModal}
              />
            ) : (
              <BasicModal
                title={
                  "Update shop user request raised. It will be updated within 24 hours."
                }
                success={true}
                setState={setShowModal}
              />
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
